import { render, staticRenderFns } from "./BpGrossProfitNumberDisplayer.vue?vue&type=template&id=fae4c6c8"
import script from "./BpGrossProfitNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpGrossProfitNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports